module.exports = __webpack_public_path__ + "static/media/cy.2d8320b2.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/cy.svg
// module id = 2073
// module chunks = 0